import { createApi } from '@reduxjs/toolkit/query/react';

import { HttpMethod } from 'enums';

import { baseQuery } from './base-query';
import { Banner } from '../types/banners.types';

export enum NewsApiTag {
  News = 'News',
}

interface FetchNewsParams {
  readonly isActive?: boolean;
}

export const newsApi = createApi({
  baseQuery,
  reducerPath: 'newsApi',
  tagTypes: [NewsApiTag.News],
  endpoints: (build) => ({
    fetchNews: build.query<Banner[], FetchNewsParams | void>({
      query: (params?: FetchNewsParams) => ({
        url: 'news',
        method: HttpMethod.GET,
        params: params ? { isActive: params.isActive } : undefined,
      }),
      providesTags: [NewsApiTag.News],
    }),
  }),
});

export const { useFetchNewsQuery } = newsApi;
